import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import QRCode from 'react-qr-code'
import { Row, Col, Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useUiGet } from '../utils/useUiGet'
import { useFirebase } from 'react-redux-firebase'
import { CircularProgress, DialogContent } from '@material-ui/core'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

const enhance = connect(({ firebase: { auth, profile } }) => ({
  auth,
  profile,
}))


function FasttrackQR({ auth, open, onClose, appconfig }) {
  const { t } = useTranslation()
  const firebase = useFirebase()
  const uiGet = useUiGet({ appconfig })
  const authUid = auth ? auth.uid : null
  const [loading, setLoading] = useState(false)
  const [oneTimeToken, setOneTimeToken] = useState(null)
  const [token, setToken] = useState(null)
  const [processing, setProcessing] = useState(false)
  const [showEntry, setShowEntry] = useState(false)
  const [backgroundColor, setBackgroundColor] = useState('white')
  const [message, setMessage] = useState('')



  useEffect(() => {
    if (open && !token) {
      uiGet({ customerid: appconfig.accountkey, q: 'getQrToken' })
        .then((result) => {
          console.log('fasttrackqr result', result)
          setToken(result.data.token)
          setOneTimeToken(result.data.fullToken)
          setLoading(false)
        })
        .catch((error) => {
          console.error('fasttrackqr error', error)
        })
    }
  }, [open, uiGet, token, appconfig.accountkey])

  useEffect(() => {
    // clear token when dialog is closed
    if (!open) {
      setToken(null)
      setProcessing(false)
      setShowEntry(false)
      setBackgroundColor('white')
      setMessage('')
      setOneTimeToken(null)
    }
  }, [open])

  useEffect(() => {
    // demo mode: procing after 10 seconds
    // then show entry after another 10 seconds
    if (open && token) {
      const demoProcessingTimeout = setTimeout(() => {
        setProcessing(true)
        setMessage('processing')
        setBackgroundColor('#f0ad4e') // light orange
        const demoShowEntryTimeout = setTimeout(() => {
          setProcessing(false)
          setShowEntry(true)
          setMessage('entry_granted')
          setBackgroundColor('#3af695') // light green
          // auto close after 10 seconds
          setTimeout(() => {
            onClose()
          }, 10000)
        }, 10000)
        return () => clearTimeout(demoShowEntryTimeout)
      }, 10000)
      return () => clearTimeout(demoProcessingTimeout)
    }
  }, [open, token, onClose])

  useEffect(() => {
    // listen for QR code updates from firebase database
    console.log('fasttrackqr useEffect token', token)
    if (token) {
      const tokenRef = firebase.database().ref(`devices/qrTokens/${token}`)
      tokenRef.on('value', (snapshot) => {
        const data = snapshot.val()
        console.log('fasttrackqr data update', data)
        if (data && data.status) {
          if (data.status === 'used') {
            console.log('fasttrackqr token used, closing dialog')
            onClose()
          }
          if (data.status === 'processing') {
            setProcessing(true)
            setMessage(data.message || 'processing')
            setBackgroundColor('#f0ad4e') // light orange
          }
          if (data.status === 'processed') {
            setProcessing(false)
            if (data.action === 'show_entry') {
              setShowEntry(true)
              setMessage(data.message || '')
              setBackgroundColor('#3af695') // light green
              // auto close after 10 seconds
              setTimeout(() => {
                onClose()
              }, 10000)
            } else {
              console.log('fasttrackqr unknown action', data.action)
            }
          }
        }
      })
      return () => {
        tokenRef.off()
      }
    }
  }, [token, firebase, onClose])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='qr-dialog-title'
      aria-describedby='qr-dialog-description'
      fullScreen={true}
      fullWidth={true}
      slots={{
        transition: Transition,
      }}
    >
      <DialogContent style={{ backgroundColor: backgroundColor }}>
        <Row>
          <Col className='text-right' style={{ padding: 20 }}>
            <Button color='secondary' onClick={onClose}>
              {t('close')}
            </Button>
          </Col>
        </Row>
        {loading && <Row style={{ padding: 20 }}>
          <Col className='text-center' xs={12} sm={12} md={12} lg={12}>
            <CircularProgress />
          </Col>
        </Row>
        }
        {!loading && oneTimeToken && authUid &&
          <Row style={{ padding: 20 }}>
            <Col className='text-center' xs={12} sm={12} md={12} lg={12}>
              <QRCode value={oneTimeToken} size={256} level={'M'} />
            </Col>
          </Row>
        }
        {!processing && !showEntry ? (
          <Row style={{ padding: 20 }}>
            <Col className='text-center' style={{ marginTop: 10 }}>
              {t('fasttrack_qr_instructions')}
            </Col>
          </Row>
        ) : null}

        <Row style={{ padding: 20 }}>
          <Col className='text-center'>
            {processing && !showEntry && <div><CircularProgress /><div>{t(message)}</div></div>}
            {showEntry && <div>{t(message)}</div>}
          </Col>
        </Row>
      </DialogContent>
    </Dialog>
  )
}

export default enhance(FasttrackQR)
